/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingIdCancelMutationResponse, PostApiBookingIdCancelPathParams, PostApiBookingIdCancelQueryParams } from "../entities/PostApiBookingIdCancel";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBookingIdCancel } from "../api/postApiBookingIdCancel";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBookingIdCancelMutationKey = () => [{ url: '/api/booking/:id/cancel' }] as const

export type PostApiBookingIdCancelMutationKey = ReturnType<typeof postApiBookingIdCancelMutationKey>

export function postApiBookingIdCancelMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = postApiBookingIdCancelMutationKey()
        return mutationOptions<PostApiBookingIdCancelMutationResponse, ResponseErrorConfig<Error>, {id: PostApiBookingIdCancelPathParams["id"], params: PostApiBookingIdCancelQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ id, params }) => {
            return postApiBookingIdCancel(id, params, config)
          },
        })

}

/**
 * @description Отмена записи на стрижку
 * @summary Отменить запись
 * {@link /api/booking/:id/cancel}
 */
export function usePostApiBookingIdCancel<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBookingIdCancelMutationResponse, ResponseErrorConfig<Error>, {id: PostApiBookingIdCancelPathParams["id"], params: PostApiBookingIdCancelQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBookingIdCancelMutationKey()

          const baseOptions = postApiBookingIdCancelMutationOptions(config) as UseMutationOptions<PostApiBookingIdCancelMutationResponse, ResponseErrorConfig<Error>, {id: PostApiBookingIdCancelPathParams["id"], params: PostApiBookingIdCancelQueryParams}, TContext>
          

          return useMutation<PostApiBookingIdCancelMutationResponse, ResponseErrorConfig<Error>, {id: PostApiBookingIdCancelPathParams["id"], params: PostApiBookingIdCancelQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBookingIdCancelMutationResponse, ResponseErrorConfig<Error>, {id: PostApiBookingIdCancelPathParams["id"], params: PostApiBookingIdCancelQueryParams}, TContext>
      
}